import React from "react";
import SatisfactionRecord from "../satisfaction-record/SatisfactionRecord";
import SupportDepartment from "../support-department/SupportDepartment";
import './ContactUs.scss'
import { GroupUser } from "../../../models/interfaces/management/GroupUser";

export default class ContactUs extends React.PureComponent {
  render(): React.ReactNode {
    return (
      <>
        <div className="contact-us-area">
          <SatisfactionRecord groupUser={GroupUser.Assistant} title="مشاور" />
          <SatisfactionRecord groupUser={GroupUser.Supporter} title="پشتیبان" />
          <SatisfactionRecord groupUser={GroupUser.Psychologist} title="روانشناس" />
          <SatisfactionRecord groupUser={GroupUser.Top_Student} title="رتبه برتر" />
          <SupportDepartment />
        </div>
      </>
    );
  }
}
